import { getTimeZones, TimeZone } from "@vvo/tzdb";
import { TimezoneOption } from "../timezones.types";
import makeTimezoneOptionFromTzdbTimezone from "./makeTimezoneOptionFromTzdbTimezone";

export function getTimezoneOptions(): TimezoneOption[] {
  const timezones = getTimeZones({ includeUtc: true });

  // Deduplicate by "name" (the canonical field in tzdb)
  const seen = new Set<string>();

  const timezoneOptions = timezones
    .filter((timezone: TimeZone) => {
      if (seen.has(timezone.name)) return false;
      seen.add(timezone.name);
      return true;
    })
    .map((timezone: TimeZone) => {
      return makeTimezoneOptionFromTzdbTimezone(timezone);
    });

  return timezoneOptions;
}

export default getTimezoneOptions;

